module.exports = __webpack_public_path__ + "img/chip02.8afc7b6e.png";